import script from "./PasswordInputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordInputField.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordInputField.vue?vue&type=style&index=0&id=47178ae6&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47178ae6"]])

export default __exports__